<template>
<div>
    <!-- <div class="hero-about bg-alt h-500"></div> -->
    
    <div class="py-md-3 py-lg-5 px-6 center">
            <div class="pt-10" style="max-width: 1080px;">
                <h1 class="mb-5">Project Gallery</h1>
                <div class="center">
                    <vue-picture-swipe :items="images" :options="{showHideOpacity:true}"></vue-picture-swipe>
                </div>
            </div>
    </div>
</div>
</template>

<script>
import VuePictureSwipe from 'vue-picture-swipe'

export default {
	name: 'gallery',
	data: function() {
		return {
			images: [
				{
					src: require('@/assets/gallery/render1.jpg'),
					thumbnail: require('@/assets/gallery/render1-thumb.jpg'),
					w: 1280,
					h: 682
				},
				{
					src: require('@/assets/gallery/render2.jpg'),
					thumbnail: require('@/assets/gallery/render2-thumb.jpg'),
					w: 1280,
					h: 896
				},
				{
					src: require('@/assets/gallery/render3.jpg'),
					thumbnail: require('@/assets/gallery/render3-thumb.jpg'),
					w: 1280,
					h: 658
				},
				{
					src: require('@/assets/gallery/interior.jpg'),
					thumbnail: require('@/assets/gallery/interior-thumb.jpg'),
					w: 1200,
					h: 853
				},
				{
					src: require('@/assets/gallery/kitchen.jpg'),
					thumbnail: require('@/assets/gallery/kitchen-thumb.jpg'),
					w: 1280,
					h: 853
				},
				{
					src: require('@/assets/gallery/kitchen3.jpg'),
					thumbnail: require('@/assets/gallery/kitchen3-thumb.jpg'),
					w: 1280,
					h: 853
				},
				{
					src: require('@/assets/gallery/bathroom.jpg'),
					thumbnail: require('@/assets/gallery/bathroom-thumb.jpg'),
					w: 1280,
					h: 853
				},
				{
					src: require('@/assets/gallery/modern.jpg'),
					thumbnail: require('@/assets/gallery/modern-thumb.jpg'),
					w: 1280,
					h: 960
				},
				{
					src: require('@/assets/gallery/house1.jpg'),
					thumbnail: require('@/assets/gallery/house1-thumb.jpg'),
					w: 1280,
					h: 960
				},
				{
					src: require('@/assets/gallery/house2.jpg'),
					thumbnail: require('@/assets/gallery/house2-thumb.jpg'),
					w: 1280,
					h: 615
				},
				{
					src: require('@/assets/gallery/lounge.jpg'),
					thumbnail: require('@/assets/gallery/lounge-thumb.jpg'),
					w: 1280,
					h: 615
				},
				{
					src: require('@/assets/gallery/bathroom2.jpg'),
					thumbnail: require('@/assets/gallery/bathroom2-thumb.jpg'),
					w: 1280,
					h: 615
				}
			]
		}
	},

	components: {
		'vue-picture-swipe': VuePictureSwipe
	},
	head: {
		title: {
			inner: '3D House Gallery | Canberra 3D Drafting | Canberra House Plans'
		},
		meta: [
			{
				name: 'description',
				content: 'View Home Solutions Design Groups latest client projects',
				id: 'desc'
			}
		]
	}
}
</script>

<style>
figure a img {
	max-width: 100%;
	margin-top: 10px;
}

@media screen and (min-width: 782px) {
	.my-gallery figure a img {
		width: calc(100% / 2 - 10px);
	}
}

@media screen and (min-width: 992px) {
	.my-gallery figure a img {
		width: calc(100% / 3 - 10px);
	}
}
</style>


// WEBPACK FOOTER //
// src/components/Gallery.vue